import React, { Component } from "react";
import Swal from "sweetalert2";
import BetterCircularProgress from "../../../components/BetterCircularProgress";
import { getDashboard } from "../../../crud/dashboard.crud";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";

export default class DashboardPage extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            data: {
                contratos_criados: 0,
                contratos_assinados: 0,
                contratos_pagos: 0,
            },
        };
    }

    componentDidMount = () => {
        this.setState({ loading: false });

        getDashboard()
            .then((res) => {
                if (res.data.errors) {
                    return Swal.fire("Ops!", res.data.errors[0], "error");
                }

                this.setState({ data: res.data, loading: false });
            })
            .catch(() => Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"));
    };

    render() {
        return (
            <BetterCircularProgress loading={this.state.loading}>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid #385FA5` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Total de contratos criados</span>

                                        <span className="kt-widget26__number color-gray-900">{this.state.data?.criados}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid #385FA5` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Total de contratos assinados</span>

                                        <span className="kt-widget26__number color-gray-900">{this.state.data?.assinados}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: `4px solid #385FA5` }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc color-gray-600">Total de contratos pagos</span>

                                        <span className="kt-widget26__number color-gray-900">{this.state.data?.pagos}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>
                </div>
            </BetterCircularProgress>
        );
    }
}
